// src/components/session/WordDisplay.js

import { useFurigana } from '../../hooks/useFurigana';

const FURIGANA_ACTIVE_PADDING_TOP = 'pt-1';
const FURIGANA_CONTAINER_HEIGHT_CLASSES = 'max-h-4';

const WordDisplay = ({ item, learnedWordIds = new Set() }) => {
  const [showFurigana] = useFurigana();
  const hasFurigana = item.word !== item.kana;
  const isLearned = item.isLearned || learnedWordIds.has(item.id);

  const baseClasses = 'inline-block align-bottom p-2 sm:p-3 mx-0.5 rounded-xl shadow-md transition-colors duration-200 ease-in-out';
  const stateClasses = isLearned
    ? 'bg-green-100 dark:bg-green-900/50 border-2 border-green-400 dark:border-green-600'
    : 'bg-background-secondary border-2 border-border';

  return (
    <div className={`${baseClasses} ${stateClasses}`} lang="ja">
      <div className="flex flex-col items-center justify-center h-full">
        {' '}
        {/* Added h-full for consistency */}
        {/* Furigana container: controlled by showFurigana */}
        <div
          className={`text-sm font-normal text-content-secondary transition-all duration-225 ease-in-out overflow-hidden
                                ${showFurigana && hasFurigana ? `${FURIGANA_CONTAINER_HEIGHT_CLASSES} opacity-100` : 'max-h-0 opacity-0'}
                                flex items-end`}
        >
          <span className="leading-tight">{item.kana}</span>
        </div>
        {/* Main word: conditionally apply padding-top when furigana is shown */}
        <span
          className={`text-2xl sm:text-3xl font-bold leading-tight text-content-primary
                                ${showFurigana && hasFurigana ? FURIGANA_ACTIVE_PADDING_TOP : ''}`}
        >
          {item.word}
        </span>
      </div>
    </div>
  );
};

export default WordDisplay;
